import { onMounted, onUnmounted } from 'vue'
import type { CmsShortcutAction } from '@nsftx/seven-client-retail-vue-sgp'
import { registerShortcutAction } from './shortcutsService'
import type { ShortcutActionHandler } from './shortcutsTypes'

export const useShortcut = (action: CmsShortcutAction,  callback: ShortcutActionHandler, local = false) => {
  let unregisterShortcut: () => void | undefined

  onMounted(() => {
    unregisterShortcut = registerShortcutAction(action, callback, local)
  })

  onUnmounted(() => {
    unregisterShortcut?.()
  })
}
